import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { APP_CONFIG } from './assets/config/config';
import { environment } from './environments/environment';


// Determine which config file to load based on the environment
const configFile = environment.production 
  ? '/assets/config/config.prod.json' 
  : '/assets/config/config.dev.json';

// Fetch the config file before bootstrapping the app
fetch(configFile)
  .then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.status} ${response.statusText}`);
    }
    return response.json();
  })
  .then((config) => {
    
    // Store the config globally so Keycloak can access it
    (window as any).keycloakLoadedConfig = {
      url: config.keycloak.url,
      realm: config.keycloak.realm,
      clientId: config.keycloak.clientId
    };
    // Merge the loaded config into the application providers
    const extendedConfig = {
      providers: [
        ...appConfig.providers,
        { provide: APP_CONFIG, useValue: config }
      ]
    };

    // Bootstrap the application with the extended configuration
    return bootstrapApplication(AppComponent, extendedConfig);
  })
  .then(() => {
    console.log('🎉 Angular App Bootstrapped Successfully');
  })
  .catch((error) => {
    console.error('❌ Could not load application configuration:', error);
  });